import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React, {useState, useEffect} from "react";
import "./Header.css";
import {useHistory} from "react-router-dom";
import { deepOrange } from '@mui/material/colors';

const Header = ({ children, hasHiddenAuthButtons }) => {
  /**-->to implement the loggedin and loggedout logic.
   * when rendereing the state gets updated;
   */

   const[isLoggedIn, setLogStatus] = useState(false);

   const history= useHistory()

       const onlineStatus =()=>{
         if(localStorage.getItem('token')!==null){
           
           return setLogStatus(true)
         }
         return setLogStatus(false)
       }
   
       const goOffline=()=>{ 
        
       localStorage.removeItem("token");
       localStorage.removeItem("username");
       localStorage.removeItem("balance")
       window.location.reload()
       history.push("/")
       
         onlineStatus()
       }

    useEffect(()=>{
      onlineStatus()
    },[])

    // var token = localStorage.getItem('token');

    // console.log(`this is ${token} value`)

  //--> implement useHistory to go to Products page
  

  const exploreProducts=()=>{
    history.push("/")
  }

  const Login=()=>{
    return(<Button   onClick={()=>{history.push("/login")}}>LOGIN</Button>)
  }

  const Register=()=>{
    return(<Button variant="contained" onClick={(e)=>{history.push("/register")}}>Register</Button>)
  }

  // const Avatar=()=>{
  //   return (<Avatar alt={localStorage.getItem('username')} src="avatar.png" />)
  // }

  // const storage=()=>{
  //   let storage= localStorage.getItem('username')
  //   return storage
  // }
  // const Logout=()=>{
  //   return(<Button variant="contained"  onClick={()=>{localStorage.removeItem('username')}}>LOGOUT</Button>)
  // }

    return (
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>
        <Box
      sx={{
        width: 500,
        maxWidth: '100%',
      }}
    >
        {children}
       </Box>
          
        
        { 
        hasHiddenAuthButtons ?
           <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={()=>{exploreProducts()}}
        >
          Back to explore
        </Button>

        : (<Stack >
          { isLoggedIn ? 
          <Stack direction ="row" spacing={2} >
          <Avatar alt={localStorage.getItem('username')} src="avatar.png" />
          <p style={{marginTop: 7}}>{localStorage.getItem('username')}</p>
          <Button variant="contained"  
          onClick={goOffline}>LOGOUT</Button>
          </Stack>
          :
          <Stack direction ="row" spacing={2} >
           <Login />
           <Register />
           </Stack>
          
          }
         </Stack>)
        }
      </Box>
  
    );
};

export default Header;
